"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openStateMethods = exports.no = exports.yes = exports.rule = exports.codeList = exports.code = void 0;
const lit_1 = require("lit");
/** 문서 문장 안의 컴포넌트명·코드 식별자를 mm-code로 감싼다. */
// 앞뒤 공백이 문장 안 여백으로 렌더되지 않도록 한 줄로 둔다.
// prettier-ignore
const code = (name) => (0, lit_1.html) `<mm-code>${name}</mm-code>`;
exports.code = code;
/** 여러 식별자를 쉼표로 이어 mm-code로 감싼다. */
// prettier-ignore
const codeList = (names) => names.map((name, index) => (0, lit_1.html) `${index ? ', ' : ''}${(0, exports.code)(name)}`);
exports.codeList = codeList;
/** 규칙 목록 항목. 해야 할 일을 굵은 한 줄로 먼저 두고 설명을 잇는다. */
const rule = (title, description) => (0, lit_1.html) `
  <span>
    <mm-text weight="bold">${title}</mm-text>
    ${description}
  </span>
`;
exports.rule = rule;
/** 표 칸의 예·아니오 표시. 이모지만으로는 뜻이 읽히지 않으므로 이름을 함께 단다. */
exports.yes = (0, lit_1.html) `
  <span role="img" aria-label="예">✅</span>
`;
exports.no = (0, lit_1.html) `
  <span role="img" aria-label="아니오">❌</span>
`;
/** withOpenState를 쓰는 표면이 함께 갖는 공개 메서드. 선언에서 읽을 수 없어 문서에 따로 적는다. */
exports.openStateMethods = [
    { name: 'show()', type: 'method' },
    { name: 'close()', type: 'method' },
    { name: 'toggle()', type: 'method' },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LmhlbHBlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21wb25lbnQuaGVscGVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBK0M7QUFJL0MsMkNBQTJDO0FBQzNDLHFDQUFxQztBQUNyQyxrQkFBa0I7QUFDWCxNQUFNLElBQUksR0FBRyxDQUFDLElBQVksRUFBRSxFQUFFLENBQUMsSUFBQSxVQUFJLEVBQUEsWUFBWSxJQUFJLFlBQVksQ0FBQTtBQUF6RCxRQUFBLElBQUksUUFBcUQ7QUFFdEUsbUNBQW1DO0FBQ25DLGtCQUFrQjtBQUNYLE1BQU0sUUFBUSxHQUFHLENBQUMsS0FBZSxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsSUFBQSxVQUFJLEVBQUEsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxHQUFHLElBQUEsWUFBSSxFQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQTtBQUFuRyxRQUFBLFFBQVEsWUFBMkY7QUFFaEgsK0NBQStDO0FBQ3hDLE1BQU0sSUFBSSxHQUFHLENBQUMsS0FBOEIsRUFBRSxXQUFvQyxFQUFFLEVBQUUsQ0FBQyxJQUFBLFVBQUksRUFBQTs7NkJBRXJFLEtBQUs7TUFDNUIsV0FBVzs7Q0FFaEIsQ0FBQTtBQUxZLFFBQUEsSUFBSSxRQUtoQjtBQUVELG9EQUFvRDtBQUN2QyxRQUFBLEdBQUcsR0FBRyxJQUFBLFVBQUksRUFBQTs7Q0FFdEIsQ0FBQTtBQUNZLFFBQUEsRUFBRSxHQUFHLElBQUEsVUFBSSxFQUFBOztDQUVyQixDQUFBO0FBRUQsbUVBQW1FO0FBQ3RELFFBQUEsZ0JBQWdCLEdBQTRCO0lBQ3ZELEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsUUFBUSxFQUFFO0lBQ2xDLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsUUFBUSxFQUFFO0lBQ25DLEVBQUUsSUFBSSxFQUFFLFVBQVUsRUFBRSxJQUFJLEVBQUUsUUFBUSxFQUFFO0NBQ3JDLENBQUEifQ==